import { Languages } from "src/common/descriptions/types";
import { PayableContractDebitsDescriptions } from "./types";

const DescriptionsEnUs: PayableContractDebitsDescriptions = {
    TITLE: "Accounts Payables",
    TABLE: {
        ACTION_BUTTON: "",
        SEARCH_PLACEHOLDER: "Search",
        LOADING_DATA: "Loading data...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        CUSTOMER: "Customer",
        DESCRIPTION: "Description",
        TOTAL: "Total",
        OUTSTANDING: "Outstanding",
        STATUS: "Status",
        ACTIONS: "Actions",
        ELLAPSED: "Ellapsed",
    },
    MAIN_ACTION_TITLE: "Getting information",
    MAIN_ACTION_DESCRIPTION: "Please wait...",
    DEBIT_STATUS: {
        PENDING_PAYMENT: "Pending payment",
        PAYED: "Payed",
        ABOLISHED: "Abolished",
        EXPIRED: "Expired",
    },
    DAYS: "days",
}

const DescriptionsEsUs: PayableContractDebitsDescriptions = {
    TITLE: "Cuentas por Pagar",
    TABLE: {
        ACTION_BUTTON: "Crear Contrato",
        SEARCH_PLACEHOLDER: "Buscar Contrato",
        LOADING_DATA: "Cargando datos...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        CUSTOMER: "Cliente",
        DESCRIPTION: "Descripción",
        TOTAL: "Total",
        OUTSTANDING: "Pendiente",
        STATUS: "Estado",
        ACTIONS: "Acciones",
        ELLAPSED: "Transcurrido",
    },
    MAIN_ACTION_TITLE: "Obteniendo información",
    MAIN_ACTION_DESCRIPTION: "Por favor espera...",
    DEBIT_STATUS: {
        PENDING_PAYMENT: "Pendiente pago",
        PAYED: "Pagada",
        ABOLISHED: "Anulada",
        EXPIRED: "Vencida",
    },
    DAYS: "días",
}

export const payableContractDebitsDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}